<template>
  <div id="Signin">
    <div class="top">
      <p class="title">
        每日签到
      </p>
      <div class="right">
        <router-link to="/Records" tag="span">奖励记录 ></router-link>
        <span  @click="toLink()"  >荣誉榜单 ></span>
      </div>
      <p class="click">
        <span :class="{gray:flag==false}" @click="goSignin()"><img  src="../assets/images/activity/clickget.png" />{{state}}</span>
      </p>
      <p class="first">累积签到<span>{{totalDays}}</span>天</p>
      <p class="first">连续签到第<span>{{continueDays}}</span>天，继续加油</p>
    </div>
    <Calendar class="datecal" ref="Calendar1"
      :markDateMore=arr
      v-on:changeMonth="changeDate"
    ></Calendar>
  </div>
</template>

<script>
// 关于我们
import Calendar from 'vue-calendar-component';
export default {
  name: 'Signin',
  components:{Calendar},
  created(){
    this.Global.getShareConfig({
      title: '每日签到福利',
      desc: '签到抽豪礼，不要错过咯~'
    },this)
  },
  data(){
    return{
      arr:[],
      state:"点我签到",
      data:'',
      bgurl:'../assets/images/activity/center.png',
      flag:false,//能否签到
      checkInId:'',
      totalDays:'',//累计签到天数
      continueDays:'',//连续签到天数
      first:true
    }
  },
  methods:{
    toLink(){
      if(!this.checkInId){
        return;
      }else{
        this.$router.push('/List?checkInId='+this.checkInId)
      }
    },
    // 切换月份
    changeDate(data){
      if(!this.checkInId){
        return;
      }
      if(this.first){
        this.first = false;
        return;
      }
      this.arr = [];
      var date = ''
      if(data.split('/')[1]<10){
        date =  data.split('/')[0]+'-0'+data.split('/')[1];
      }else{
        date =  data.split('/')[0]+'-'+data.split('/')[1];
      }
      this.axios({
        method: "POST",
        url: `/checkin/history-days`,
        data:{
          date:date,
          checkId:this.checkInId
        },
        headers: {
          Authorization: `Bearer ${this.Global.getCookie("token")}`
        }
      }).then(res => {
        
        var len = res.data.data.monthDays.length;
        var date1 = new Date();
        var day = ''
        day = date;
        // 本年本月
        if(data.split('/')[1] == (Number(date1.getMonth())+1) && data.split('/')[0] == date1.getFullYear()){
          for(var i = 0;i<len;i++){
            var pushday = ''
            if(res.data.data.monthDays[i] == 1){
              pushday = day + '/'+(i+1);
              this.arr.push({date:pushday,className:"mark1"})
            }else if(i+1<date1.getDate()){
              pushday = day + '/'+(i+1);
              this.arr.push({date:pushday,className:"mark2"})
            }
          }
        // 小于本年本月
        }else if(data.split('/')[1] < (Number(date1.getMonth())+1) && data.split('/')[0] == date1.getFullYear()){
          // console.log('下雨',len)
          for(var j = 0;j<len;j++){
            var pushday1 = ''
            // console.log(res.data.data.monthDays[j])
            if(res.data.data.monthDays[j] == 1){
              pushday1 = day + '/'+(j+1);
              this.arr.push({date:pushday1,className:"mark1"})
            }else{
              pushday1 = day + '/'+(j+1);
              this.arr.push({date:pushday1,className:"mark2"})
            }
          }
        }
        
        //  this.arr = res.data.data.monthDays
      })
    },
    // 点击立即签到
    goSignin(){
      if(this.flag){ //判断是否有签到资格
        this.axios({
          method: "POST",
          url: `/checkin/check-in-record`,
          data:{
            data:this.data
          },
          headers: {
            Authorization: `Bearer ${this.Global.getCookie("token")}`
          }
        }).then(res => {
          // 0 成功 3失败
            if(res.data.code == 0){
              this.$toast('签到成功')
              this.state = '已签到'
              this.flag = false;
              this.totalDays = this.totalDays +1;
              this.continueDays = this.continueDays +1;

              var date = new Date();var day = ''
              day = date .getFullYear(); //获取完整的年份(4位)
              day = day + '/'+(Number(date.getMonth())+1); //获取当前月份(0-11,0代表1月)
              day = day + '/'+date .getDate(); //获取当前日(1-31)
              this.arr.push({date:day,className:"mark1"})
              setTimeout(function(){
                // 两个一起配合关闭
                window.opener = null;   
                window.open("about:blank", "_top").close()  
              },1500) 
            }else{
              this.$toast('签到失败')
            }
        })
      }
    },
    // 检查签到资格
    getCheckIn(){
      this.axios({
        method: "GET",
        url: `/checkin?data=${this.data}`,
        headers: {
          Authorization: `Bearer ${this.Global.getCookie("token")}`
        }
      }).then(res => {
        // Code:0成功1签到链接无效2签到时间已过
        if(res.data.code == 0){
          // 1 已签到  0 未签到
          if(res.data.data.is_check_in == 1){
            this.flag = false;
            this.state = '已签到'
          }else{
            this.flag = true;
          }
          this.checkInId = res.data.data.checkInId;
          this.totalDays = res.data.data.totalDays;
          this.continueDays = res.data.data.continueDays;
          var len = res.data.data.monthDays.length;
          var date = new Date();var day = ''
          day = date .getFullYear(); //获取完整的年份(4位)
          day = day + '/'+(Number(date .getMonth())+1); //获取当前月份(0-11,0代表1月)
          this.$refs.Calendar1.ChoseMonth(day+'/'+date.getDate());
          for(var i = 0;i<len;i++){
            var pushday = ''
            if(res.data.data.monthDays[i] == 1){
              pushday = day + '/'+(i+1);
              this.arr.push({date:pushday,className:"mark1"})
            }else if(i+1<date .getDate()){
              pushday = day + '/'+(i+1);
              this.arr.push({date:pushday,className:"mark2"})
            }
          }
        }else{
          this.$toast(res.data.message);
          this.flag = false;
          this.state = '无法签到'
        }
        // console.log(res)
      })
    }
  },
  mounted(){
    this.data = this.$route.query.data;
    this.getCheckIn();
  }
}
</script>

<style scoped>
#Signin .gray{
  filter: grayscale(1);
}
#Signin{
  background: #F9F9F9;
  position: absolute;
  height: 100vh;
  overflow: auto;
}
#Signin .datecal{
  padding: 0 1rem;
  margin-top: -2.88rem;
  border-radius: 1rem;
}
#Signin .top .first{
  text-align: center;
  font-size: 1rem;
  font-family: PingFang HK;
  color: white;
  text-shadow: 0px 1px 6px #EE6A34;
  font-weight: 300;
}
#Signin .top .first>span{
  margin: 0 0.2rem;
  font-weight: 400;
  font-size: 1.3rem;
}
#Signin .top .title{
  font-size: 1.13rem;
  color: #fff;
  text-align: center;
  padding-top: 0.8rem;
}
#Signin .top .right{
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 0;
  top: 0.8rem;
}
#Signin .top .right>span{
  padding: 0.3rem 1rem 0.3rem 1.63rem;
  background: #FFFFFF;
  border-top-left-radius: 2rem;
  border-bottom-left-radius: 2rem;
  font-size: 0.75rem;
  color: #FF5E00;
  margin-bottom: 0.38rem;
  position: relative;
}
#Signin .top .right>span:nth-child(1)::before{
  position: absolute;
  content: '';
  width: 0.66rem;
  height: 0.83rem;
  background: url(../assets/images/activity/Wallet.png) ;
  background-size: 100% 100%;
  left: 0.69rem;
}
#Signin .top .right>span:nth-child(2)::before{
  position: absolute;
  content: '';
  width: 0.8rem;
  height: 0.75rem;
  background: url(../assets/images/activity/crown.png);
  background-size: 100% 100%;
  left: 0.63rem;
}
#Signin .top .click{
  margin: 2.6rem auto 1rem;
  display: flex;  
  justify-content: center;
}
#Signin .top .click>span{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 9.72rem;
  height: 3.09rem;
  font-size: 1.25rem;
  color: #fff;
  border-radius: 5rem;
  line-height: 3.09rem;
  background: linear-gradient(275deg, #FF3045 0%, #FF8920 100%);
}
#Signin .top .click>span>img{
  width: 1.44rem;
  height: 1.5rem;
  margin-right: 0.69rem;
}
#Signin  .top{
  background: url(../assets/images/activity/bj1.jpg) no-repeat ;
  background-size: 100% 100%;
  padding-bottom: 4.51rem;
}



</style>